import './index.scss';
import React, { Component } from 'react';
import { GeckoModalService } from 'ui';
import BotTagManagerModal from '../Modal';
import BotTagManagerService from '../Service';
import { renderError } from 'services/gecko-error';

export class BotTagManagerEditBtn extends Component {
  handler(event) {
    event.stopPropagation();
    // Keep dropdown open when edit modal is opened
    BotTagManagerService.keepDropdownOpen = true;
    // Open edit modal
    new GeckoModalService()
      .open(this.renderModal.bind(this))
      .catch(renderError);
  }

  renderModal() {
    return <BotTagManagerModal tag={this.props.tag} />;
  }

  render() {
    return (
      <span
        className="BotTagManagerEditBtn far fa-edit"
        onClick={this.handler.bind(this)}
      ></span>
    );
  }
}

export default BotTagManagerEditBtn;
